var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C6.8187 14.5 6.64482 14.428 6.51663 14.2998C6.38843 14.1716 6.31641 13.9977 6.31641 13.8164V1.18359C6.31641 1.00229 6.38843 0.828419 6.51663 0.70022C6.64482 0.572021 6.8187 0.5 7 0.5C7.1813 0.5 7.35518 0.572021 7.48337 0.70022C7.61157 0.828419 7.68359 1.00229 7.68359 1.18359V13.8164C7.68359 13.9977 7.61157 14.1716 7.48337 14.2998C7.35518 14.428 7.1813 14.5 7 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3164 8.18359H0.683594C0.502293 8.18359 0.328419 8.11157 0.20022 7.98337C0.0720213 7.85518 0 7.6813 0 7.5C0 7.3187 0.0720213 7.14482 0.20022 7.01663C0.328419 6.88843 0.502293 6.81641 0.683594 6.81641H13.3164C13.4977 6.81641 13.6716 6.88843 13.7998 7.01663C13.928 7.14482 14 7.3187 14 7.5C14 7.6813 13.928 7.85518 13.7998 7.98337C13.6716 8.11157 13.4977 8.18359 13.3164 8.18359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.0b0747994a02a54be10e6a554a1a74e7.svg";
export { ForwardRef as ReactComponent };